import type { ChangeEvent, JSX } from 'react';

import ColorConverter from 'pkg/colorconverter';

import MaterialSymbol from 'components/material-symbols';

import * as css from './styles.css';

interface ColorPickerProps {
	name?: string;
	value: string;
	onChange: (value: string) => void;
}

/**
 * ColorPicker component
 *
 * A color selection input that displays the selected color along with an accent icon.
 */

export function ColorPicker({
	onChange,
	name,
	value,
}: ColorPickerProps): JSX.Element {
	const iconColor = ColorConverter.from(value).getAccentColor().toHEX();

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange(event.target.value);
	};

	return (
		<label className={css.colorPicker} style={{ color: value }}>
			<span className={css.swatch} style={{ color: iconColor }}>
				{value}
				<MaterialSymbol variant="colorize" />
			</span>
			<input name={name} type="color" value={value} onChange={handleChange} />
		</label>
	);
}
